import { create } from "zustand"

const settingsStore = create((set) => ({
    settings: null,
    setSettings: (settings) => set((state) => ({ ...state, settings: settings })),
}))

export default settingsStore
